import { useState } from 'react';
import { BrowserImage } from '@/components/ui/BrowserImage';
import type { PublicOrganizationProfile } from '@/services/publicOrg';

interface OrgPublicBannerProps {
  profile: PublicOrganizationProfile;
}

export function OrgPublicBanner({ profile }: OrgPublicBannerProps) {
  const [failedBannerUrl, setFailedBannerUrl] = useState<string | null>(null);
  const bannerUrl = profile.organization.bannerUrl;
  const showBanner = Boolean(bannerUrl && bannerUrl !== failedBannerUrl);
  const { organization } = profile;

  if (showBanner) {
    return (
      <div className="relative h-40 w-full overflow-hidden bg-muted sm:h-56 lg:h-64">
        <BrowserImage
          src={bannerUrl!}
          alt=""
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setFailedBannerUrl(bannerUrl!)}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 text-white">
          <div className="mx-auto max-w-7xl px-4 pb-6 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold sm:text-4xl">{organization.name}</h1>
            {organization.description ? (
              <p className="mt-2 line-clamp-2 max-w-2xl text-sm text-white/90 sm:text-base">
                {organization.description}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <header className="border-b border-border bg-card px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-foreground">{organization.name}</h1>
    </header>
  );
}
